import { StyledEditableTitle } from "../../EditorFields/EditorFields-styled";

const FeatureHeader = ({ highlightSymbol, title }) => {
  return (
    <>
      {highlightSymbol?.url ? (
        <img width={34} height={34} alt="feature" src={highlightSymbol?.url} />
      ) : highlightSymbol?.type === "simple-line" ? (
        <div
          style={{
            height: 3,
            width: 20,
            background: `rgb(${highlightSymbol.color.r}, ${highlightSymbol.color.g}, ${highlightSymbol.color.b})`,
          }}
        />
      ) : null}
      {title ? (
        <StyledEditableTitle className="header">{title}</StyledEditableTitle>
      ) : null}
    </>
  );
};

export default FeatureHeader;
